import classNames from 'classnames';
import React from 'react';

import Button, { ButtonStyles } from '@Components/Buttons/Button';
import Icon, { IconSizes } from '@Components/Icon';
import Row from '@Components/layout/Row';
import Typography from '@Components/Typography';
import { FaqItemNode } from '@Graphql/graphqlTypes.generated';

import styles from './FAQContentItem.module.scss';

interface FAQCategoriesContentItemProps {
  questions: FaqItemNode[];
  expandedQuestions: number[];
  setExpandedQuestion: (numbers: number[]) => void;
}

const FAQContentItem: React.FC<FAQCategoriesContentItemProps> = ({
  questions,
  expandedQuestions,
  setExpandedQuestion,
}) => {
  const questionsSorted = [...questions].sort((a, b) => a.orderNum - b.orderNum);

  const onIconClick = (index: number) => () => {
    if (expandedQuestions.includes(index)) {
      setExpandedQuestion(expandedQuestions.filter(question => question !== index));
    } else {
      setExpandedQuestion([...expandedQuestions, index]);
    }
  };

  return (
    <ul>
      {questionsSorted.map((question, index) => {
        return (
          <li className={classNames(styles.faqContentItem)} key={index}>
            <Row className={styles.questionTitleWrapper} alignCenter justifyBetween>
              <Button style={ButtonStyles.withoutStyling} onClick={onIconClick(index)}>
                <Typography
                  msg={question.title}
                  tag="span"
                  className={classNames(styles.questionTitle, { [styles.active]: expandedQuestions.includes(index) })}
                />
                <div className={styles.iconBox}>
                  <Icon icon={expandedQuestions.includes(index) ? 'minus' : 'plus'} size={IconSizes.m} />
                </div>
              </Button>
            </Row>
            {expandedQuestions.includes(index) && (
              <div className={styles.questionContentWrapper}>
                <Typography msg={question.text} tag="span" className={styles.questionContent} size="m" html />
              </div>
            )}
            {index !== questionsSorted.length - 1 && <div className={styles.separator} />}
          </li>
        );
      })}
    </ul>
  );
};

export default FAQContentItem;
